import { defineMessage } from 'react-intl';

/** Shown when a fragment tab requires media that is still being generated. */
export const mediaNotReadyTooltip = defineMessage({
  id: 'fragments.viewScreen.mediaNotReadyTooltip',
  defaultMessage: 'Esperando por media de fragmento',
});

/** Shown when a fragment tab requires a transcription that is still being generated. */
export const transcriptionNotReadyTooltip = defineMessage({
  id: 'fragments.viewScreen.transcriptionNotReadyTooltip',
  defaultMessage: 'Esperando por transcripción de fragmento',
});
